import React from 'react'

import { Form, Table } from '_zari/core'

const RowTemplate = ({ row, dispatch }) => {
  const [montoPago, setMontoPago] = React.useState('')
  const [checked, setChecked] = React.useState(false)

  const onChange = React.useCallback(
    e => {
      setMontoPago(e.target.value)
      dispatch({
        type: 'actualizar',
        payload: {
          ...row,
          montoPago: e.target.value
        }
      })
    },
    [row, dispatch]
  )

  const onChecked = React.useCallback(
    e => {
      const isChecked = e.target.checked
      setChecked(isChecked)

      if (isChecked) {
        setMontoPago(row.monto)
        dispatch({
          type: 'actualizar',
          payload: {
            ...row,
            montoPago: row.monto
          }
        })
      } else {
        setMontoPago('')
        dispatch({
          type: 'actualizar',
          payload: {
            ...row,
            montoPago: ''
          }
        })
      }
    },
    [row, dispatch]
  )

  return (
    <Table.Row>
      <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
      <Table.Cell>{row.fechaVencimiento || '--'}</Table.Cell>
      <Table.Cell>{row.tipoDocumento || '--'}</Table.Cell>
      <Table.Cell>{row.serieDocumento || '--'}</Table.Cell>
      <Table.Cell>{row.numeroDocumento || '--'}</Table.Cell>
      <Table.Cell>{row.moneda || '--'}</Table.Cell>
      <Table.Cell>{row.monto || '--'}</Table.Cell>
      <Table.Cell>
        <Form.InputNumber
          id={`number-monto-${row._id}`}
          name={`number-monto-${row._id}`}
          value={montoPago}
          onChange={onChange}
          disabled={checked}
        />
      </Table.Cell>
      <Table.Cell>
        <Form.Checkbox
          id={`checkbox-${row._id}`}
          name={`checkbox-${row._id}`}
          label=''
          checked={checked}
          onChange={onChecked}
        />
      </Table.Cell>
    </Table.Row>
  )
}

export default React.memo(RowTemplate)
